import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import WriterPdfPane, { type WriterPdfPaneProps } from '@/components/writer/WriterPdfPane';
import { useHorizontalSwipe } from '@/hooks/useSwipeNavigation';

interface Props extends WriterPdfPaneProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Full-height compiled-PDF sheet for the compact Writer layout. Mounts the
 * (expensive) PDF renderer only while open, so the chat surface stays fast.
 * Swiping right on the header returns to chat, mirroring the swipe-left that
 * opened it.
 */
const WriterPdfSheet: React.FC<Props> = ({ open, onOpenChange, ...paneProps }) => {
  const swipe = useHorizontalSwipe({
    enabled: open,
    onSwipeRight: () => onOpenChange(false),
  });

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="h-[92dvh] p-0 flex flex-col gap-0 rounded-t-2xl"
      >
        <SheetHeader
          className="px-4 py-3 border-b border-border/60 text-left shrink-0"
          {...swipe}
        >
          <SheetTitle className="text-sm">Compiled draft</SheetTitle>
        </SheetHeader>
        <div className="flex-1 min-h-0 flex flex-col bg-muted/20">
          {open ? <WriterPdfPane {...paneProps} compact /> : null}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default WriterPdfSheet;

